/* unplugin-vue-components disabled */import { render } from "./StoreManage.vue?vue&type=template&id=7040f69a&scoped=true"
import script from "./StoreManage.vue?vue&type=script&lang=js"
export * from "./StoreManage.vue?vue&type=script&lang=js"

import "./StoreManage.vue?vue&type=style&index=0&id=7040f69a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7040f69a"]])

export default __exports__